import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom, timeout } from 'rxjs';

import { environment } from '../../environments/environment';
import { ApiResponse } from '../types/auth.types';

export interface SistemaInfoAdicional {
  mantenimiento?: string;
  actualizacion?: string;
  informacion?: string;
}

export interface SistemaStatus {
  estatus: boolean;
  infoAdicional?: SistemaInfoAdicional | null;
}

@Injectable({ providedIn: 'root' })
export class SistemaStatusService {
  private readonly http = inject(HttpClient);
  private readonly _status = signal<SistemaStatus>({ estatus: true });
  private _promise: Promise<void> | null = null;
  private _lastFetch = 0;
  private readonly TTL_MS = 30_000;

  readonly status = this._status.asReadonly();

  loadStatus(): Promise<void> {
    const now = Date.now();
    if (this._promise && now - this._lastFetch < this.TTL_MS) {
      return this._promise;
    }
    this._lastFetch = now;
    this._promise = firstValueFrom(
      this.http.get<ApiResponse<SistemaStatus>>(
        `${environment.apiUrl}/Sistema/status`
      ).pipe(timeout(3000))
    )
      .then((res) => {
        if (res?.isSuccess && res.data) {
          this._status.set(res.data);
        }
      })
      .catch(() => {
        // Falla silenciosamente: se asume activo para no bloquear el acceso
      });
    return this._promise;
  }

  /** Fuerza un re-fetch en la próxima llamada a loadStatus */
  reset(): void {
    this._promise = null;
    this._lastFetch = 0;
  }
}
